/** Ease into and out of the first 160px of scrolling, including reversal. */
export function reviewHeaderProgress(scrollTop: number): number {
  const progress = Math.min(1, Math.max(0, scrollTop) / 160);
  return progress * progress * (3 - 2 * progress);
}

/** Header heights in px; below `lg` the actions take a row of their own. */
const REVIEW_HEADER_HEIGHTS = {
  narrow: { expanded: 188, compact: 124 },
  wide: { expanded: 148, compact: 48 },
} as const;

/**
 * The header's height at a progress, and the height it has handed to the
 * scroll viewport below it. The page adds that give-back as bottom spacing so
 * the scroll range never depends on the header: without it, collapsing near
 * the end of a page shrinks the range, the browser clamps the scroll position
 * back, the header re-expands, and the two chase each other every frame.
 */
export function reviewHeaderLayout(
  progress: number,
  wide: boolean,
): { readonly height: number; readonly giveBack: number } {
  const { expanded, compact } = REVIEW_HEADER_HEIGHTS[wide ? "wide" : "narrow"];
  const giveBack = (expanded - compact) * progress;
  return { height: expanded - giveBack, giveBack };
}
